
import { formatColumnNameFollowCKLogic } from "./helper";
/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlCorpcd(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-")[0].toString().length < 1) return "";
  return childInf.split("-")[0].toString().substring(0, 1);
}

/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlOfficecd(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-")[0].toString().length < 3) return "";
  return childInf.split("-")[0].toString().substring(1, 3);
}


/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlBlockcd(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-")[0].toString().length < 5) return "";
  return childInf.split("-")[0].toString().substring(3, 5);
}

/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlUnitcd(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-")[0].toString().length < 10) return "";
  return childInf.split("-")[0].toString().substring(7, 10).toString();
}

/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlkbn(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-").toString().length < 2) return "";
  return childInf.split("-")[1].toString();
}

/// <summary>
/// 1030100000-703-003
/// childInf = OWNUNITCD-TTLKBN-TTLCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getChildTtlcd(childInf:any) :any{
  if (!childInf) return "";
  if (childInf.split("-").toString().length < 3) return "";
  return childInf.split("-")[2].toString();
}

/// <summary>
/// 1030100000-703-003-1
/// childInf = OWNUNITCD-TTLKBN-TTLCD-ITEMCD
/// OWNUNITCD　＝
///         1　　➞CORPCD
///         03 　➞OFFICECD
///         01 　➞BLOCKCD
///         00 　➞補助
///         001 ➞UNITCD
/// </summary>
/// <param name="childInf"></param>
/// <returns></returns>
export function getParentInf(ttlParent:any) : any {
  var parentinf = "";
  if (ttlParent.parentinf) {
    parentinf = `${ttlParent.parentinf}_${ttlParent.corpcd}${ttlParent.officecd}${ttlParent.blockcd}00${ttlParent.unitcd}-${ttlParent.ttlkbn}-${ttlParent.ttlcd}-${ttlParent.itemid}`;
  } else {
    parentinf = `${ttlParent.corpcd}${ttlParent.officecd}${ttlParent.blockcd}00${ttlParent.unitcd}-${ttlParent.ttlkbn}-${ttlParent.ttlcd}-${ttlParent.itemid}`;
  }
  return parentinf;
}

/**
 * Format column item follow CK logic
 * @param column is data source column item has columnname and displayname
 * @returns 
 */
export function formatColumnItem(column: any): any { 
    if(!column.columnname.trim().toUpperCase().startsWith("COL")
            || !column.displayname.trim().toUpperCase().startsWith("#")) return column; // Only support tag

    column.displayname = formatColumnNameFollowCKLogic(column.displayname);
    return column;
  }